import actionTypes from "../actionTypes";
import IAction from "../../types/IAction";
import { getErrorMessage } from "../../utils/helpers";
import { ERROR, errorNotification } from "../../utils/notifications";
import { readMessageBack } from "../../utils/readMessageBack";

interface State {
  binnaclePartner: object[];
  binnaclePartnerLoading: boolean;
  binnaclePartnerError: object;
  binnaclePartnerMembership: object[];
  binnaclePartnerMembershipLoading: boolean;
  binnaclePartnerMembershipError: object;
  modules: string[];
  loadingModules: boolean;
  modulesError: object;
}

const initialState: State = {
  binnaclePartner: null,
  binnaclePartnerLoading: false,
  binnaclePartnerError: null,
  binnaclePartnerMembership: null,
  binnaclePartnerMembershipLoading: false,
  binnaclePartnerMembershipError: null,
  modules: [],
  loadingModules: false,
  modulesError: null
};

export default function binnacleReducer(
  state: State = initialState,
  action: IAction
): State {
  switch (action.type) {
    case `${actionTypes.GET_ACTIVITY_LOGS_BY_PARTNER}_PENDING`: {
      return {
        ...state,
        binnaclePartnerLoading: true,
        binnaclePartnerError: null
      };
    }
    case `${actionTypes.GET_ACTIVITY_LOGS_BY_PARTNER}_REJECTED`: {
      errorNotification(readMessageBack(action, ERROR));
      return {
        ...state,
        binnaclePartner: null,
        binnaclePartnerLoading: false,
        binnaclePartnerError: getErrorMessage(action.payload)
      };
    }
    case `${actionTypes.GET_ACTIVITY_LOGS_BY_PARTNER}_FULFILLED`: {
      return {
        ...state,
        binnaclePartner: action.payload.data,
        binnaclePartnerLoading: false,
        binnaclePartnerError: null
      };
    }
    case `${actionTypes.GET_ACTIVITY_LOGS_BY_PARTNER_MEMBERSHIP}_PENDING`: {
      return {
        ...state,
        binnaclePartnerMembershipLoading: true,
        binnaclePartnerMembershipError: null
      };
    }
    case `${actionTypes.GET_ACTIVITY_LOGS_BY_PARTNER_MEMBERSHIP}_REJECTED`: {
      errorNotification(readMessageBack(action, ERROR));
      return {
        ...state,
        binnaclePartnerMembership: null,
        binnaclePartnerMembershipLoading: false,
        binnaclePartnerMembershipError: getErrorMessage(action.payload)
      };
    }
    case `${actionTypes.GET_ACTIVITY_LOGS_BY_PARTNER_MEMBERSHIP}_FULFILLED`: {
      return {
        ...state,
        binnaclePartnerMembership: action.payload.data,
        binnaclePartnerMembershipLoading: false,
        binnaclePartnerMembershipError: null
      };
    }
    case `${actionTypes.GET_ACTIVITY_LOGS_MODULES}_PENDING`: {
      return {
        ...state,
        loadingModules: true,
        modulesError: null
      };
    }
    case `${actionTypes.GET_ACTIVITY_LOGS_MODULES}_REJECTED`: {
      errorNotification("Ocurrio un error al cargar los módulos");
      return {
        ...state,
        modules: [],
        loadingModules: false,
        modulesError: getErrorMessage(action.payload)
      };
    }
    case `${actionTypes.GET_ACTIVITY_LOGS_MODULES}_FULFILLED`: {
      return {
        ...state,
        modules: Array.isArray(action.payload.data) ? action.payload.data : [],
        loadingModules: false,
        modulesError: null
      };
    }
    case actionTypes.RESET_ACTIVITY_LOGS: {
      return {
        ...initialState
      };
    }
    default: {
      return state;
    }
  }
}

export { initialState };
